export default "__VITE_ASSET__AXeLimcI__"